import { makeStyles, tokens } from '@fluentui/react-components';

const INLINE_PREVIEW_TIMELINE_MAX_HEIGHT = '60vh';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    gap: tokens.spacingVerticalM,
    minWidth: 0,
  },
  rootFill: {
    flexGrow: 1,
    flexShrink: 1,
    minHeight: 0,
    padding: 0,
    boxShadow: 'none',
    backgroundColor: tokens.colorTransparentBackground,
  },
  summaryRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    columnGap: tokens.spacingHorizontalS,
    rowGap: tokens.spacingVerticalXXS,
    flexShrink: 0,
  },
  headerAction: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
  },
  headingText: {
    fontWeight: tokens.fontWeightSemibold,
    fontSize: tokens.fontSizeBase400,
    color: tokens.colorNeutralForeground1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
  },
  summary: {
    color: tokens.colorNeutralForeground2,
  },
  timeline: {
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    gap: 0,
  },
  scrollableTimeline: {
    maxHeight: INLINE_PREVIEW_TIMELINE_MAX_HEIGHT,
    overflowY: 'auto',
    overscrollBehavior: 'contain',
  },
  fillTimeline: {
    flexGrow: 1,
    flexShrink: 1,
    minHeight: 0,
    overflowY: 'auto',
    overscrollBehavior: 'contain',
    padding: 0,
    boxShadow: 'none',
    borderTopStyle: 'none',
    borderRightStyle: 'none',
    borderBottomStyle: 'none',
    borderLeftStyle: 'none',
    backgroundColor: tokens.colorTransparentBackground,
  },
  turn: {
    display: 'grid',
    flexShrink: 0,
    gridTemplateColumns: 'max-content minmax(0, 1fr)',
    columnGap: tokens.spacingHorizontalL,
    padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalM}`,
    ':hover': {
      backgroundColor: tokens.colorNeutralBackground2Hover,
    },
    ':hover [data-expected-action-add]': {
      opacity: 1,
    },
    ':focus-within [data-expected-action-add]': {
      opacity: 1,
    },
  },
  actionSlot: {
    gridColumnStart: '2',
    display: 'flex',
    marginTop: tokens.spacingVerticalXS,
    opacity: 0,
    transitionProperty: 'opacity',
    transitionDuration: tokens.durationFaster,
  },
  attachmentSlot: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
    padding: `0 ${tokens.spacingHorizontalM} ${tokens.spacingVerticalM}`,
  },
  chatTurn: {
    backgroundColor: tokens.colorNeutralBackground2,
    borderLeftColor: tokens.colorNeutralStroke1,
    borderLeftStyle: 'solid',
    borderLeftWidth: tokens.strokeWidthThick,
  },
  userQueryTurn: {
    backgroundColor: tokens.colorBrandBackground2,
    borderLeftColor: tokens.colorBrandStroke1,
    borderLeftStyle: 'solid',
    borderLeftWidth: tokens.strokeWidthThick,
  },
  position: {
    color: tokens.colorNeutralForeground3,
    fontFamily: tokens.fontFamilyMonospace,
    whiteSpace: 'nowrap',
    paddingTop: tokens.spacingVerticalXS,
  },
  message: {
    minWidth: 0,
    width: '100%',
  },
  heading: {
    display: 'flex',
    alignItems: 'baseline',
    flexWrap: 'wrap',
    gap: tokens.spacingHorizontalS,
  },
  speaker: {
    fontWeight: tokens.fontWeightSemibold,
  },
  text: {
    whiteSpace: 'pre-wrap',
    overflowWrap: 'anywhere',
    lineHeight: tokens.lineHeightBase300,
  },
  empty: {
    padding: tokens.spacingVerticalXXL,
    textAlign: 'center',
    color: tokens.colorNeutralForeground3,
  },
});
